import { FC } from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import {
  LoginButton,
  LoginIcon,
  LoginMessage,
  LoginRequiredContainer,
  LoginTitle,
} from './OcLoginRequired.styled';

export interface OcLoginRequiredProps {
  loginUrl: string;
}

export const OcLoginRequired: FC<OcLoginRequiredProps> = ({
  loginUrl,
}) => {
  const { loginTitle, loginHelpText, loginButtonText } = useOcFabWidgetOptions();

  return (
    <LoginRequiredContainer>
      <LoginIcon
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
        <polyline points="10 17 15 12 10 7" />
        <line x1="15" y1="12" x2="3" y2="12" />
      </LoginIcon>
      <LoginTitle>{loginTitle}</LoginTitle>
      <LoginMessage>{loginHelpText}</LoginMessage>
      <LoginButton href={loginUrl}>{loginButtonText}</LoginButton>
    </LoginRequiredContainer>
  );
};

